import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileLanguagePreferencesEditorActions'

const initialState = {
  submitting: false,
  loadingLanguages: false,
  editingLanguages: false,
  languagePreferencesBeforeEditing: [],
  profile: {
    languagePreferences: []
  },
  languagePreferences: {
    allLanguages: [],
    editingLanguages: false,
    isInvalid: {
      languages: {
        isInvalid: false,
        message: null
      },
      formIsValid: true
    }
  }
}

const minimumRequiredSelection = 1

export default function reducer(state = initialState, action) {
  const { edit, fetch, set } = events

  switch (action.type) {
    case edit.start: {
      const newState = copyLanguagePreferencesState(state)

      const selectedLanguages = newState.profile?.languagePreferences || []

      newState.languagePreferences.editingLanguages = true
      newState.languagePreferencesBeforeEditing = cloneDeep(selectedLanguages)

      newState.languagePreferences.languagePreferences.isInvalid.languages =
        validateChecklistField(selectedLanguages, minimumRequiredSelection)

      newState.languagePreferences.languagePreferences.isInvalid.formIsValid =
        formIsValid(newState.languagePreferences.languagePreferences.isInvalid)

      return newState
    }

    case edit.stop: {
      return {
        ...state,
        languagePreferences: {
          ...state.languagePreferences,
          editingLanguages: false
        }
      }
    }

    case edit.cancel: {
      const newState = copyLanguagePreferencesState(state)

      newState.languagePreferences.editingLanguages = false
      newState.profile.languagePreferences = cloneDeep(
        newState.languagePreferencesBeforeEditing || []
      )
      newState.languagePreferencesBeforeEditing = []

      return newState
    }

    case fetch.fetched: {
      return {
        ...state,
        languagePreferences: {
          ...state.languagePreferences,
          allLanguages: action.payload || []
        }
      }
    }

    case set.selectionChanged: {
      const newState = copyLanguagePreferencesState(state)

      const selectedLanguages = newState.profile?.languagePreferences || []

      const index = selectedLanguages.findIndex(
        (l) => l.languageId === action.language.languageId
      )

      if (index > -1) {
        selectedLanguages.splice(index, 1)
      } else {
        selectedLanguages.push(action.language)
      }

      newState.languagePreferences.languagePreferences.isInvalid.languages =
        validateChecklistField(selectedLanguages, minimumRequiredSelection)

      newState.languagePreferences.languagePreferences.isInvalid.formIsValid =
        formIsValid(newState.languagePreferences.languagePreferences.isInvalid)

      newState.edited = true

      return newState
    }

    default:
      return state
  }
}


function copyLanguagePreferencesState(state) {
  const newState = cloneDeep(state)

  newState.profile = cloneDeep(state.profile || {})
  newState.profile.languagePreferences = cloneDeep(
    state.profile?.languagePreferences || []
  )

  return newState
}

/**
 * Validation helpers
 */
function formIsValid(isInvalid) {
  return isInvalid?.languages?.isInvalid !== 'error'
}


function validateChecklistField(list = [], minRequired) {
  if (!list || list.length < minRequired) {
    return {
      isInvalid: 'error',
      message: `Select at least ${minRequired} item(s)`
    }
  }

  return {
    isInvalid: false,
    message: null
  }
}
